module.exports = __webpack_public_path__ + "static/media/services.b7c06804.svg";